<template>
  <footer class="mt-12">
    <div class="container mx-auto border-t border-gray-500">
      <div class="w-full p-4 mx-auto text-center m-8">
        <div class="text-sm text-gray-600">
          Made with ❤️ by
          <a
            href="https://github.com/azmi6298"
            class="text-gray-600 font-semibold"
            >azmi6298</a
          >
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>